import { render, staticRenderFns } from "./MediaCoverage.vue?vue&type=template&id=3fb2afa5&scoped=true"
import script from "./MediaCoverage.vue?vue&type=script&lang=js"
export * from "./MediaCoverage.vue?vue&type=script&lang=js"
import style0 from "./MediaCoverage.vue?vue&type=style&index=0&id=3fb2afa5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb2afa5",
  null
  
)

export default component.exports